import React from "react";

const defaultHeaderConfig = {
  logo: false,
  home: false,
  title: "",
};
export const privateRoutes = [
  {
    Path: "/dashboard",
    Component: React.lazy(() => import("../component/Dashboard/Dashboard")),
    meta: {
      name: "Dashboard page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: true,
    },
    id: "dashboard",
  },
  {
    Path: "/orders",
    Component: React.lazy(() => import("../component/Orders/Orders")),
    meta: {
      name: "Order page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: true,
    },
    id: "orders",
  },
  {
    Path: "/reports",
    Component: React.lazy(() => import("../component/Table/index")),
    meta: {
      name: "Order page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: true,
    },
    id: "reports",
  },
];

export const publicRoutes = [
  {
    Path: "/login",
    Component: React.lazy(() => import("../container/Login")),
    meta: {
      name: "Login page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: true,
    },
    id: "login",
  },
  {
    Path: "/policies-and-conditions/:title",
    Component: React.lazy(() => import("../container/PoliciesAndConditions")),
    meta: {
      name: "TnC page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: false,
    },
    id: "tnc",
  },
];

export default { privateRoutes, publicRoutes };
